import { render, staticRenderFns } from "./CategoryListItem.vue?vue&type=template&id=39f187fe"
import script from "./CategoryListItem.vue?vue&type=script&lang=js"
export * from "./CategoryListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports